/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LifeTransactionStatus = {
    Paid: 'Paid',
    Pending: 'Pending',
    Returned: 'Returned',
    Cancelled: 'Cancelled',
    Unknown: 'Unknown'
} as const;
export type LifeTransactionStatus = typeof LifeTransactionStatus[keyof typeof LifeTransactionStatus];


export function instanceOfLifeTransactionStatus(value: any): boolean {
    for (const key in LifeTransactionStatus) {
        if (Object.prototype.hasOwnProperty.call(LifeTransactionStatus, key)) {
            if (LifeTransactionStatus[key as keyof typeof LifeTransactionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LifeTransactionStatusFromJSON(json: any): LifeTransactionStatus {
    return LifeTransactionStatusFromJSONTyped(json, false);
}

export function LifeTransactionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LifeTransactionStatus {
    return json as LifeTransactionStatus;
}

export function LifeTransactionStatusToJSON(value?: LifeTransactionStatus | null): any {
    return value as any;
}

export function LifeTransactionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LifeTransactionStatus {
    return value as LifeTransactionStatus;
}

